var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M23.933 2L3 9.285 6.308 36.408 23.955 46 41.693 36.278 45 9.156z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b71c1c",
    d: "M42.818 10.527L24 4.135 24 43.695 39.832 35.017z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M23.941 4.115L5.181 10.644 8.168 35.143 23.951 43.721 24 43.695 24 4.135z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M24 5.996L24 15.504 32.578 34 36.987 34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M11.013 34L15.422 34 24 15.504 24 5.996z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M24 24H30V28H24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M18 24H24V28H18z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.7543950faa02680e77406ceeece0c330.svg";
export { ForwardRef as ReactComponent };